module.exports = __webpack_public_path__ + "img/1i_Dashboard.628377f1.png";